import { handleActions } from 'redux-actions';
import { merge } from 'lodash-es';

import {
  DISPLAY_SETTINGS_FETCH_SUCCESS,
  DISPLAY_SETTINGS_SET_START_CHANNEL,
  DISPLAY_SETTINGS_YAMMER_IS_LOADED,
  DISPLAY_SETTINGS_MICROSOFT_TEAMS_IS_LOADED,
  DISPLAY_SETTINGS_FACEBOOK_SDK_IS_LOADED,
  ADD_TOGGLES,
} from 'common/actions/settings';
import { DISPLAY_SETTINGS_UPDATE_HOME_START_VIDEO } from 'components/mark-unmark-start-home-video';

const initialState = {
  display: null,
};

export const settingsReducer = handleActions(
  {
    [DISPLAY_SETTINGS_FETCH_SUCCESS]: (prevState, { payload: { settings } }) => {
      return {
        ...prevState,
        display: settings,
      };
    },

    [DISPLAY_SETTINGS_SET_START_CHANNEL]: (prevState, { payload: { startChannels } }) => {
      return {
        ...prevState,
        display: {
          ...prevState.display,
          startChannels,
        },
      };
    },
    [DISPLAY_SETTINGS_UPDATE_HOME_START_VIDEO]: (prevState, { payload: { startVideoId } }) => {
      return {
        ...prevState,
        display: {
          ...prevState.display,
          homePage: {
            ...prevState.display.homePage,
            startVideoId: startVideoId,
          },
        },
      };
    },
    [DISPLAY_SETTINGS_YAMMER_IS_LOADED]: (prevState) => {
      return merge({}, prevState, {
        display: {
          features: {
            ShareViaYammer: {
              loaded: true,
            },
          },
        },
      });
    },
    [DISPLAY_SETTINGS_MICROSOFT_TEAMS_IS_LOADED]: (prevState) => {
      return merge({}, prevState, {
        display: {
          features: {
            ShareViaMicrosoftTeams: {
              loaded: true,
            },
          },
        },
      });
    },
    [DISPLAY_SETTINGS_FACEBOOK_SDK_IS_LOADED]: (prevState) => {
      return merge({}, prevState, {
        display: {
          features: {
            ShareViaFacebook: {
              loaded: true,
            },
          },
        },
      });
    },
    [ADD_TOGGLES]: (prevState, { payload }) => {
      return merge({}, prevState, {
        featureToggles: payload,
      });
    },
  },
  initialState
);
